window.addEventListener("DOMContentLoaded", () => {
	const faq = document.querySelector('.faq-module .faq-wrapper')
	if(faq){
		const items = faq.querySelectorAll('.item')
		items.forEach(item=>{
			//get init answer's height
			const answer = item.querySelector('.answer')
			answer.setAttribute('style', `--tooltip-height:${answer.scrollHeight}px`)
			//update height when window resizes
			window.addEventListener('resize', ()=>{
				answer.style.height = 'auto'
				answer.setAttribute('style', `--tooltip-height:${answer.scrollHeight}px`)
			})
			//header click handle
			const question = item.querySelector('.question')
			question.addEventListener('click', ()=>{
				item.classList.toggle('active')
			})
		})
	}
});
